import TextAreaInput from 'components/forms/inputs/rhf-inputs/TextAreaInput.tsx';
import { ModalFooter } from 'components/modals/ModalFooter.tsx';
import { ModalHeader } from 'components/modals/ModalHeader.tsx';
import React from 'react';
import { useForm } from 'react-hook-form';
import { BankTransactionDetails, BankTransactionUpdateDto } from 'types/bank-transfers.ts';
import { t } from 'utils/getTranslations.ts';
import { logError } from 'utils/monitoring';

interface BankTransactionNotesFormData {
    transactionNotes?: string;
}

interface Props {
    bankTransfer: BankTransactionDetails;
    onClose: () => void;
    onSubmit: (value: BankTransactionUpdateDto) => { unwrap: () => Promise<BankTransactionDetails> };
    onBankTransferUpdated: (details: BankTransactionDetails) => void;
}

const BankTransactionNotesModal: React.FC<Props> = ({ bankTransfer, onClose, onSubmit, onBankTransferUpdated }) => {
    const { handleSubmit, control } = useForm<BankTransactionNotesFormData>({
        defaultValues: {
            transactionNotes: bankTransfer.transactionNotes || '',
        },
    });

    const onSave = () => {
        handleSubmit(async (data) => {
            const dto: BankTransactionUpdateDto = {
                id: bankTransfer.id,
                amountNoninvoice: bankTransfer.amountNoninvoice,
                noninvoiceNotes: bankTransfer.noninvoiceNotes,
                transactionNotes: data.transactionNotes,
                isNonInvoiceTransaction: bankTransfer.isNonInvoiceTransaction,
                invoicePayments: bankTransfer.invoicePayments.map((payment) => ({
                    invoicePaymentId: payment.id,
                    invoiceId: payment.invoice.id,
                    amountInTransactionCurrency: payment.amountInTransactionCurrency,
                })),
            };
            await onSubmit(dto)
                .unwrap()
                .then((response) => {
                    onBankTransferUpdated(response);
                    onClose();
                })
                .catch((error) => {
                    console.error(error);
                    logError(error);
                });
        })();
    };

    return (
        <>
            <ModalHeader title={t('bank-transfers.edit-transaction-notes')} onCancel={onClose} />
            <div className="h-full overflow-y-auto px-6 py-3 max-sm:px-4 max-sm:py-6">
                <div className="flex flex-row gap-4">
                    <TextAreaInput
                        control={control}
                        label="bank-transfers.transaction-notes"
                        placeholder="bank-transfers.transaction-notes"
                        name="transactionNotes"
                        minRows={10}
                        enableAutofill
                    />
                </div>
            </div>
            <ModalFooter onCancel={onClose} onSave={onSave} />
        </>
    );
};

export default BankTransactionNotesModal;
